import React from 'react';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import { PC_PAGE_CONFIG } from './pcPageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { useSelector } from 'umi';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import GuideCountryComparison from '@/pages/dashboard/components/UserGuide/CountryComparison';
import { CASUAL_PAGE_CONFIG } from './casualPageConfig';
// import { ARROW_CASUAL_PAGE_CONFIG } from './arrowCasualPageConfig';

const reqParams = '/comparisonAnalysis/countryComparison';

interface PageConfigObjProp {
  [key: string]: IPageConfigType;
}

const pageConfigObj: PageConfigObjProp = {
  // @ts-ignore
  mobile: MOBILE_PAGE_CONFIG,
  // @ts-ignore
  pc: PC_PAGE_CONFIG,
  // @ts-ignore
  pc_inflexion: PC_PAGE_CONFIG,
  casual: CASUAL_PAGE_CONFIG,
  // @ts-ignore
  // arrow_casual: ARROW_CASUAL_PAGE_CONFIG
};

const CountryComparison = () => {
  const dataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile');
  
  return (
    <>
      <CommonPageRender 
        reqParams={reqParams} 
        pageConfigInit={pageConfigObj?.[dataFrame]}
      />
      {/* 新手引导 */}
      <GuideCountryComparison/>
    </>
  );
};

export default CountryComparison;
